const url = '/price-components';
const Provider = 'PriceComponents';
const dbModel = 'pricecomponents';

export { url, Provider, dbModel };
